var match = require('core/lib/match');

module.exports = {
  fieldsNeeded: ['campaign'],
  match: function(value, cond) {
    return match.hasMatch(cond.value, cond.match, value.campaign);
  },
};
